var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error-page" }, [
    _vm._m(0),
    _c("div", { staticClass: "error-desc" }, [
      _vm._v(_vm._s(_vm.$t("page_undefined"))),
    ]),
    _c(
      "div",
      { staticClass: "error-handle" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "large" },
            on: { click: _vm.goHome },
          },
          [_vm._v(_vm._s(_vm.$t("return_home_page")) + "\n    ")]
        ),
        _c(
          "el-button",
          {
            staticClass: "error-btn",
            attrs: { type: "primary", size: "large" },
            on: { click: _vm.goBack },
          },
          [_vm._v(_vm._s(_vm.$t("return_prev_page")) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error-code" }, [
      _vm._v("4"),
      _c("span", [_vm._v("0")]),
      _vm._v("4"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }